import { upperFirst } from 'lodash';

import { FromPrice, SFCCGroupPrice, SFCCProductPrice } from '@gn-audio/jss-core';

import { StandardPriceModel } from 'api/pricesApi/pricesModel';

const priceFields: (keyof StandardPriceModel)[] = [
  'productId',
  'familyId',
  'groupId',
  'sku',

  'currency',

  'discountedPrice',
  'discountedPriceWithoutVat',
  'listedPrice',
  'listedPriceWithoutVat',

  'availabilityState',
  'currency',
  'discountPercentage',
  'isDiscounted',
  'offerEndDate',
  'calloutMsg',
  'couponCalloutMessage',
  'lowestPriceInLastMonth',
];
export const mapToStandardPriceModel = (
  inputPrice: FromPrice | SFCCGroupPrice | SFCCProductPrice
): StandardPriceModel => {
  const inputPriceObject = inputPrice as Record<string, unknown>;
  return priceFields.reduce((resultPrice, fieldName) => {
    const fromField = `from${upperFirst(fieldName)}`;
    const c_field = `c_${fieldName}`;
    const value =
      inputPriceObject[fieldName] ?? inputPriceObject[fromField] ?? inputPriceObject[c_field];
    return { ...resultPrice, [fieldName]: value };
  }, {});
};
